module.exports = __webpack_public_path__ + "img/cp.fc52407a.png";